import { useEffect } from "react";
import { useLocation } from "react-router";
import { getChatId } from "../utils/utils";

function ActiveChatBridge() {
    const location = useLocation();

    useEffect(() => {
        if (!window.isInApp) return;

        const pathParts = location.pathname.split("/");

        if (pathParts[1] === "chat" && pathParts[2]) {
            // Example: /chat/{receiverId}
            const receiverId = pathParts[2];
            const uid = localStorage.getItem("uid");

            const chatId = getChatId(uid, receiverId);

            window.ReactNativeWebView.postMessage(
                JSON.stringify({
                    type: "ACTIVE_CHAT",
                    chatId: chatId,
                })
            );
        } else {
            // Not on chat page → clear active chat
            window.ReactNativeWebView.postMessage(
                JSON.stringify({
                    type: "ACTIVE_CHAT",
                    chatId: null,
                })
            );
        }
    }, [location]);

    return null; // this component doesn’t render anything
}

export default ActiveChatBridge;